import type { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog as HeadlessDialog } from '@headlessui/react';
import cn from 'classnames';

import { POPOVER_PANEL_CLASSES } from './_styles/popover';
import { Dialog } from './Dialog';
import { ModalCloseButton } from './ModalCloseButton';

interface ListDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: ReactNode;
  header?: ReactNode;
  children: ReactNode;
}

export const ListDialog: FC<ListDialogProps> = ({ isOpen, onClose, title, header, children }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      className={cn(POPOVER_PANEL_CLASSES, 'relative w-full max-w-md border-0 p-6')}
    >
      <div className="absolute right-4 top-4">
        <ModalCloseButton onClose={onClose} label={t('shared.close')} className="size-8" />
      </div>
      <HeadlessDialog.Title className="pr-8 text-xl font-semibold leading-6 tracking-[-0.4px] text-black">
        {title}
      </HeadlessDialog.Title>
      {header}
      <div className="-mx-2 mt-4 max-h-[min(60vh,420px)] overflow-y-auto px-2">{children}</div>
    </Dialog>
  );
};
